import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { v4 as uuid } from 'uuid';

export const NotificationContactDealerSkeleton = () => {
  const skeletons = [
    { id: uuid(), size: 'sm', width: '100%' },
    { id: uuid(), size: 'sm', width: '100%' },
    { id: uuid(), size: 'sm', width: '50%' },
    { id: uuid(), size: 'sm', width: '100%' },
    { id: uuid(), size: 'sm', width: '100%' },
    { id: uuid(), size: 'sm', width: '100%' },
    { id: uuid(), size: 'lg', width: '100%' },
    { id: uuid(), size: 'lg', width: '100%' }
  ];

  return (
    <>
      <CatSkeleton
        className="cat-u-display-block cat-u-margin-bottom-sm"
        size="sm"
        width="100%"
      />
      <CatSkeleton
        className="cat-u-display-block cat-u-margin-bottom-sm"
        size="sm"
        width="50%"
      />
      <hr
        style={{
          backgroundColor: '--cat-color-neutral-30',
          margin: '20px 0'
        }}
      />
      {skeletons.map((skeleton) => (
        <CatSkeleton
          key={skeleton.id}
          className="cat-u-display-block cat-u-margin-bottom-sm"
          size={skeleton.size as 'sm' | 'lg' | 'xl' | 'xxl'}
          width={skeleton.width}
        />
      ))}
    </>
  );
};
